module.exports = __webpack_public_path__ + "img/les-acteurs-du-projet.e47bd0a6.svg";